<template>
  <div class="more-popver">
    <el-tooltip class="item" v-for="(i,k) of filterData.slice(0,4)" :key="k" effect="dark" :content="i.content"

                placement="top">
    <span class="cp oper-btn" size="mini" type="info"
          @click=i.fn><i :class="i.icon.includes('back')?i.icon:'back-'+i.icon"></i>
    </span>
    </el-tooltip>

    <el-popover
      v-if="filterData.length>4"
      placement="right"
      trigger="hover">
      <div>
        <div @click="i.fn" class="cp pover" v-for="(i,k) of filterData" :key="k">
          <i :class="i.icon.includes('back')?i.icon:'back-'+i.icon"></i> <span>{{i.content}}</span>
        </div>
      </div>
      <i class="cp" slot="reference" style="vertical-align: -2px">
        <svg t="1547776946668" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2556"
             width="15" height="15">
          <defs></defs>
          <path
            d="M512 737.28c62.976 0 114.176 51.2 114.176 114.176s-51.2 114.176-114.176 114.176-114.176-51.2-114.176-114.176S449.024 737.28 512 737.28z m-114.176-225.28c0 62.976 51.2 114.176 114.176 114.176s114.176-51.2 114.176-114.176-51.2-114.176-114.176-114.176-114.176 51.2-114.176 114.176z m0-339.456C397.824 235.52 449.024 286.72 512 286.72s114.176-51.2 114.176-114.176-51.2-114.176-114.176-114.176-114.176 51.2-114.176 114.176z"
            p-id="2557" fill="#53a5fe"></path>
        </svg>
      </i>
    </el-popover>

  </div>
</template>

<script>
    export default {
        name: "operations",
        props: {
          arrData:{
            type:Array
          },
          changeSort:{
            type:Boolean,
            default:true
          }
        },
        computed:{
          filterData(){
            // let last=''
            let [arr,last]=[[],undefined];
            // let arrData=JSON.parse(this.arrData);
            // console.log(this.arrData)
            for (let i of this.arrData){
              if (this.changeSort) {
                if(i.icon.includes('chakan')||i.icon.includes('xiangqing')){
                  arr.unshift(i)
                }else if(i.icon.includes('shanchu')){
                  last=i
                }else{
                  arr.push(i)
                }
              } else {
                arr.push(i)
              }
            }
            last&&arr.push(last);
            return arr;
          }

        }
    }
</script>
<style>
  .more-popver {
    font-size: 13px;
    text-align: right;
    display: block!important;
    padding-right: 4px;
  }

  .more-popver .el-popover {
    min-width: auto;
    font-size: 13px;
    padding: 8px 12px;
    color: #53a5fe;
  }

  .pover:hover {
    background-color: #ECF5FF;
  }
</style>
